import * as agreements from "./agreements";
import * as contracts from "./contracts";
import * as posting from "./posting";
import * as navigation from "./navigation";
import * as dashboard from "./dashboard";
import * as account from "./account";
import * as profile from "./profile";
import * as work from "./work";
import * as wallet from "./wallet";
import * as pricing from "./pricing";
import * as discovery from "./discovery";
import * as company from "./company";
import * as notifications from "./notifications";
import * as detailEnglish from "./detail-en";
import * as detailTagalog from "./detail-tl";

export const en: Record<string, string> = {
  ...agreements.en,
  ...contracts.en,
  ...posting.en,
  ...navigation.en,
  ...dashboard.en,
  ...account.en,
  ...profile.en,
  ...work.en,
  ...wallet.en,
  ...pricing.en,
  ...discovery.en,
  ...company.en,
  ...notifications.en,
  ...detailEnglish.en,
  ...detailTagalog.en,
};

export const tl: Record<string, string> = {
  ...agreements.tl,
  ...contracts.tl,
  ...posting.tl,
  ...navigation.tl,
  ...dashboard.tl,
  ...account.tl,
  ...profile.tl,
  ...work.tl,
  ...wallet.tl,
  ...pricing.tl,
  ...discovery.tl,
  ...company.tl,
  ...notifications.tl,
  ...detailEnglish.tl,
  ...detailTagalog.tl,
};
